import { KeyParams } from './useInfinityActivityApplication.types';

export const getQueryKey = <T extends KeyParams>(key: string, params?: T) => {
  return [key, ...(params ? [params] : [])];
};

export enum EQueryKeys {
  INFINITY_QUERY_ACTIVITY_APPLICATION = 'infinity-query-activity-application',
}
